import React from "react";
import { Modal } from "react-bootstrap";
import crossImage from "../../public/images/close.svg";
import styles from "./commentModal.module.css";
import { Button } from "../../Common";
import { useState, useEffect } from "react";

function CommentModal({ isOpen,error, setError, onRequestClose,comment, setComment, errorMessage, setIsComment, onSave,successMessage, setSuccessMessage, setErrorMessage,loading = false,modalTitle = "Comment"   }) {

  const handleSave = () => {
    if (comment.trim() === "") {
      setError("Please add a comment.");
      setSuccessMessage("");
    } else {
      setError("");
      onSave(); 
    }
  };
  return (
    <Modal
      show={isOpen}
      onHide={onRequestClose}
      className={`${styles.modalRight}`}
      centered
    >
      <Modal.Header>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            width: "100%",
            flexDirection: "row",
          }}
        >
          <div style={{ fontSize: "18px", fontWeight: "600", color: "white" }}>
          {modalTitle}
          </div>
          <div id="crossImage">
            <img src={crossImage} alt="" onClick={() => onRequestClose()} />
          </div>
        </div>
      </Modal.Header>
      <Modal.Body id="modal-body">
        <div>
          <textarea
            id="w3review"
            placeholder={`Add ${modalTitle}`}
            onChange={(e) => {
              const value = e.target.value;
              setComment(value);
              setIsComment(value);
              setError("");
              if (value.trim() !== "") setError("");
            }}
            name="w3review"
            rows="3"
            style={{ padding: "10px", borderRadius: "8px", width: "100%" }}
          />
          {error && (
            <div style={{ color: "red", marginTop: "5px", fontSize: "14px" }}>
              {error}
            </div>
          )}
          {errorMessage && (
            <div style={{ color: "red", marginTop: "5px", fontSize: "14px" }}>
              {errorMessage}
            </div>
          )}
          {successMessage && (
            <div style={{ color: "green", marginTop: "5px", fontSize: "14px" }}>
              {successMessage}
            </div>
          )}
          <div
            style={{
              marginTop: "10px",
              display: "flex",
              width: "50%",
              gap:"20px"
              
            }}
          >

              <Button
              onClick={onRequestClose}
              title={"Cancel"}
              width={"100%"}
              disabled={loading} 
            />
            <Button
              onClick={handleSave}
              title={"Confirm"}
              width={"100%"}
              loading={loading}
              disabled={loading}
            />
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
}

export default CommentModal;
